import React, { useEffect } from "react";
import Textfield from "Components/UI/Form/Textfield";

import Grid from "@mui/material/Grid";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import SelectWithClear from "Components/UI/Form/SelectWithClear";
import { useAccountCharts } from "Context/AccountCharts";
import { InputLabel } from "@mui/material";

export default function EndcustomerArticleForm({
  formData,
  handleInputChange,
  payRuleOptions,
  payTypeOptions
}) {
  const { fetchAccountCharts, accountCharts } = useAccountCharts();

  useEffect(() => {
    if (!accountCharts || accountCharts.length === 0) {
      fetchAccountCharts();
    }
  }, [accountCharts]);

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <Textfield disabled label="ID" value={formData.Id} />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Textfield
            label="Namn"
            autoFocus={true}
            value={formData.Name}
            onChange={(e) => handleInputChange("Name", e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <FormControl fullWidth margin="dense" sx={{ textAlign: "left" }}>
            <SelectWithClear
              name="DebetAccount"
              label="Debet konto"
              value={formData.DebitAccountChartId}
              onChange={(e) =>
                handleInputChange("DebitAccountChartId", e.target.value)
              }
            >
              {accountCharts.map((accountChart) => (
                <MenuItem key={accountChart.Id} value={accountChart.Id}>
                  {`${accountChart.AccountNumber} - ${accountChart.Name}`}
                </MenuItem>
              ))}
            </SelectWithClear>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <FormControl fullWidth margin="dense" sx={{ textAlign: "left" }}>
            <SelectWithClear
              name="CreditAccount"
              label="Kredit konto"
              value={formData.CreditAccountChartId}
              onChange={(e) =>
                handleInputChange("CreditAccountChartId", e.target.value)
              }
            >
              {accountCharts.map((accountChart) => (
                <MenuItem key={accountChart.Id} value={accountChart.Id}>
                  {`${accountChart.AccountNumber} - ${accountChart.Name}`}
                </MenuItem>
              ))}
            </SelectWithClear>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Textfield
            label="Moms (VAT)"
            value={formData.VAT}
            type="number"
            onChange={(e) => handleInputChange("VAT", e.target.value)}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <FormControl fullWidth margin="dense" sx={{ textAlign: "left" }}>
            <SelectWithClear
              name="Payrule"
              label="Betalregel"
              value={formData.Payrule}
              onChange={(e) => handleInputChange("Payrule", e.target.value)}
            >
              {payRuleOptions.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </SelectWithClear>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <FormControl fullWidth margin="dense" sx={{ textAlign: "left" }}>
            <SelectWithClear
              name="Paytype"
              label="Betaltyp"
              value={formData.Paytype}
              onChange={(e) => handleInputChange("Paytype", e.target.value)}
            >
              {payTypeOptions.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </SelectWithClear>
          </FormControl>
        </Grid>
      </Grid>
    </>
  );
}
